import defaults from 'lodash/defaults';
import getSplashApiClient from 'lib/SplashApiClient/singleton';

const DEFAULT_COLLAB_LIMIT = 20;
const DEFAULT_PAGE = 1;

/**
 * Wraps a SplashApiClient with User API actions
 */
export default class UserApiClient {
    /**
     * @param {SplashApiClient} apiClient
     */
    constructor(apiClient) {
        this.apiClient = apiClient;
    }

    fetchUser() {
        return this.apiClient.get('/me');
    }

    /**
     * Fetch a provided list of user permissions
     *
     * @param   {array<string>}  permissionCodes
     *
     * @return  {promise}
     */
    fetchUserPermissions(permissionCodes) {
        return this.apiClient.get('/me/permissions/access', {
            permission_codes: permissionCodes.join(','),
        });
    }

    fetchUsersGroups(options) {
        return this.apiClient.get('/me/groups', options);
    }

    fetchUsersOrgMemberCount() {
        return this.apiClient.get('/organization/users/count');
    }

    /**
     * Get users based on passed criteria
     * @param  {object} options
     * @param  {number} options.limit - Max # of results
     * @param  {number} options.page - Page to fetch based on limit
     * @return {promise}
     */
    fetchOrgUsers(options) {
        const fetchOptions = defaults(options, {
            limit: DEFAULT_COLLAB_LIMIT,
            page: DEFAULT_PAGE,
        });

        return this.apiClient.get('/organization/users', fetchOptions);
    }

    fetchUsersCollaborators(options = {}) {
        const fetchOptions = defaults(options, {
            limit: DEFAULT_COLLAB_LIMIT,
        });

        return this.apiClient.get('/events/collaborators/users', fetchOptions);
    }

    /**
     * Syncs the logged in user with a provided FB account
     *
     * @param   {string}  facebookId
     * @param   {string}  facebookAccessToken  returned by `FB.getAccessToken()`
     *
     * @return  {promise}
     */
    syncFacebookAccount(facebookId, facebookAccessToken) {
        const data = {
            facebook_id: facebookId,
            facebook_access_token: facebookAccessToken,
        };
        return this.apiClient.put('/user/facebook/sync', data);
    }
}

export const getUserApiClient = () => new UserApiClient(getSplashApiClient());
